import React, { Component } from 'react';
import './StatisticsBanner.css'


export default class StatisticsBanner extends Component {
    render() {
        return (
            <div>
                <img className='StatisticsBanner' src='images/statisticsbanner.jpg' alt='Statistics Banner' />
            </div>
        )
    }
}
